// extracted by mini-css-extract-plugin
export default {"wrapper":"Tooltip_wrapper_q8u7P","trigger":"Tooltip_trigger_KYF8k","content":"Tooltip_content__GuHH"};